import patch from './patch';

export default ({ id, data }) => (dispatch, _getState) =>
  dispatch(patch({
    ui: { [id]: data },
  }));
